<template>
  <van-tabbar v-if="currentRole === 0" v-show="isShowFooter" active-color="#FC3159" inactive-color="#0D0E15" route>
    <van-tabbar-item to="/home">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/home-@2x.png') : require('@/assets/home@2x.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/advisory">
      <span>服务资讯</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/advisory-@2x.png') : require('@/assets/advisory@2x.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/guide">
      <span>作品上传</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/shangchuan-.png') : require('@/assets/shangchuan.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/music/list">
      <span>我的作品</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/music-@2x.png') : require('@/assets/music@2x.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/me">
      <span>个人中心</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/me-@2x.png') : require('@/assets/me@2x.png')">
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <van-tabbar v-else-if="currentRole === 1" v-show="isShowFooter" active-color="#FC3159" inactive-color="#0D0E15" route>
    <van-tabbar-item to="/agent/index">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/home-@2x.png') : require('@/assets/home@2x.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/advisory">
      <span>服务资讯</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/advisory-@2x.png') : require('@/assets/advisory@2x.png')">
      </template>
    </van-tabbar-item>
     <van-tabbar-item to="/guide">
      <span>作品上传</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/shangchuan-.png') : require('@/assets/shangchuan.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/agent/downline" icon="music-o">
      <span>我的代理</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/agent-@2x.png') : require('@/assets/agent@2x.png')">
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/me">
      <span>个人中心</span>
      <template #icon="props">
        <img :src="props.active ? require('@/assets/me-@2x.png') : require('@/assets/me@2x.png')">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Footer',
  computed: {
    isShowFooter() {
      return ['Home', 'Music', 'MusicList', 'Me', 'AgentIndex', 'AgentDownline', 'Advisory', 'Guide'].includes(this.$route.name)
    },
    ...mapState(['currentRole'])
  }
}
</script>

<style lang="scss" scoped>

</style>
